export default __webpack_public_path__ + "static/media/xray.c4ebf4fb.svg";